<template>
  <div class="field-wrapper field-wrapper--large field-wrapper--checkbox">
    <div :class="[field.cssClass]">
      <p
        v-if="field.labelPlacement !== 'hidden_label'"
        class="label label-checkbox"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </p>

      <div class="field-group field-group--checkbox">

        <div class="input-checkbox-wrapper">
          <template v-for="(item, choiceKey) in field.choices">
            <input :id="'choice-'+ formId + '_' + fieldKey + '-' + choiceKey"
                   :class="[field.adminLabel.replace(/ /g,'_'), {'input--content': field.type === 'consent'}]"
                   v-model="choice"
                   :value="item.value"
                   :required="field.type === 'consent' && field.isRequired"
                   :name="field.adminLabel.replace(/ /g,'_')"
                   type="checkbox">
            <label :for="'choice-'+ formId + '_' + fieldKey + '-' + choiceKey">
              <span class="input-checkbox-text"
                    v-html="field.type === 'consent' ? field.checkboxLabel : item.text"></span>
            </label>
          </template>
        </div>
      </div>
    </div>

    <slot name="description"></slot>
    <slot name="error"></slot>
  </div>
</template>

<script>
import store from '../store';
export default {
  store,
  name: "VFieldCheckbox",
  data () {
    return {
      choice: []
    }
  },
  props: {
    formId: Number,
    field: Object,
    fieldKey: Number
  },

  mounted() {

    const preCheckedValue = this.field.choices.find(item => item.isSelected);

    if (preCheckedValue) {
      this.choice = preCheckedValue.value
    }

  },

  watch: {
    choice: {
      immediate: true,
      deep: false,
      handler (newValue) {
        Object.keys(this.$store.state.user_form_data).map(key => {
          if (key.indexOf('input_' + this.field.id + '_') > -1) {
            store.commit(
                'DELETE_ATTRIBUTE_FORM_DATA',
                key)
          }
        })

        for (let [key, value] of Object.entries(newValue)) {

          store.commit(
              'UPDATE_USER_FORM_DATA' ,
              {'key': this.field.id + '_' + (parseInt(key) + 1), 'value': value})

        }

        store.commit(
            'DELETE_ATTRIBUTE_FORM_DATA',
            'input_' + this.field.id
        )
      }
    }
  }

}
</script>
